function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import classnames from 'classnames';
import Arrow from './components/arrow/arrow';
import { showSEODescription } from './constants';
import classes from './category-description.scss';
class CategoryDescription extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      isDescriptionTextShown: false
    });
    _defineProperty(this, "setDefaultDescriptionState", () => {
      this.setState({
        isDescriptionTextShown: this.props.currentCategory.isDescriptionShownByDefault
      });
    });
    _defineProperty(this, "handleDescriptionBlockClick", () => {
      const {
        isDescriptionTextShown
      } = this.state;
      this.setState({
        isDescriptionTextShown: !isDescriptionTextShown
      });
    });
  }
  componentDidMount() {
    this.setDefaultDescriptionState();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.currentCategory._id !== this.props.currentCategory._id) {
      this.setDefaultDescriptionState();
    }
  }
  render() {
    const {
      isDescriptionBlockShown,
      isDescriptionBlockOpen,
      descriptionTitle,
      descriptionText,
      isFilterPopupOpen,
      withAnimation
    } = this.props;
    const {
      isDescriptionTextShown
    } = this.state;
    const isDescriptionTextHidden = !showSEODescription || !isDescriptionBlockOpen && (!descriptionText || !isDescriptionTextShown);
    const showArrow = !isDescriptionBlockOpen && descriptionText && showSEODescription;
    return isDescriptionBlockShown ? /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.container, {
        [classes.containerWithOpenedFilterPopup]: isFilterPopupOpen
      })
    }, /*#__PURE__*/React.createElement("div", {
      className: classnames({
        [classes.activeFilter]: isFilterPopupOpen,
        [classes.spacer]: withAnimation
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.content
    }, showArrow && /*#__PURE__*/React.createElement(Arrow, {
      onClick: this.handleDescriptionBlockClick,
      isShown: isDescriptionTextShown
    }), descriptionTitle && /*#__PURE__*/React.createElement("h1", {
      className: classes.title
    }, descriptionTitle), /*#__PURE__*/React.createElement("div", {
      className: classnames(classes.description, {
        [classes.hidden]: isDescriptionTextHidden
      })
    }, descriptionText))) : /*#__PURE__*/React.createElement("div", {
      className: classes.styleSeparator
    });
  }
}
export default CategoryDescription;